module.exports = __webpack_public_path__ + "static/media/18922508_1841641486099979_8250494035275833758_o.59cb290f.jpg";